import { generateUID } from '../../../../shared/utils';
import { FormNodeModel } from '../models/FormsNode.model';
import { FormNodeDTO, FormNodeRequestDTO } from '../types';
import { FormInputUtil } from './FormInputUtils';

export class FormNodeUtil {
  public static mapToViewModel(dto: FormNodeDTO): FormNodeModel {
    return {
      id: dto.id,
      header: dto.header,
      description: dto.description,
      footer: dto.footer,
      nodeInputs: dto.nodeInputs
        ? dto.nodeInputs.map((input) => FormInputUtil.mapToViewModel(input))
        : [],
    };
  }

  public static toRequestDTO(model?: FormNodeModel): FormNodeRequestDTO {
    return {
      id: model ? model.id : generateUID(),
      header: model ? model.header : '',
      description: model ? model.description : undefined,
      footer: model ? model.footer : undefined,
      nodeInputs: model
        ? model.nodeInputs.map((input) => FormInputUtil.toRequestDTO(input))
        : [],
    };
  }
}
